import React from 'react';

//@ts-ignore
export default function CustomTable() {
  const tableStyles: React.CSSProperties = {
    borderCollapse: 'collapse',
    width: '882px',
    margin: '20px auto',
    fontFamily: 'Rubik',
    border: '1px solid #000000',
  };

  const thStyles: React.CSSProperties = {
    backgroundColor: '#091A49',
    color: '#FFFFFF',
    padding: '14px 31px',
    border: '1px solid #000000',
    fontFamily: 'Rubik',
    fontWeight: 700,
    fontSize: '36px',
    lineHeight: '43px',
    textAlign: 'center',
  };

  const tdStyles: React.CSSProperties = {
    padding: '10px 40px',
    color: '#000000',
    border: '1px solid #000000',
    fontFamily: 'Rubik',
    fontWeight: 400,
    fontSize: '36px',
    lineHeight: '66px',
    textAlign: 'center',
    height: '77px',
  };

  const columns = [
    {
      name: 'Ethereum',
      abbr: 'ETH',
    },
    {
      name: 'Tether',
      abbr: 'USDT',
    },
    {
      name: 'USD Coin',
      abbr: 'USDC',
    },
    {
      name: 'Bitcoin',
      abbr: 'BTC',
    },
  ];

  return (
    <table style={tableStyles}>
      <thead>
        <tr>
          <th style={thStyles}>Name of the Token</th>
          <th style={thStyles}>Abbreviation</th>
        </tr>
      </thead>
      <tbody>
        {columns.map((column, index) => (
          <tr key={index}>
            <td style={tdStyles}>{column.name}</td>
            <td style={tdStyles}>{column.abbr}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
